import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const Person: ITypeSpecificPolicy<types.Person> = {

  fields: {
    fullName: {
      read: (_, { readField }) => {
        const firstName = readField('firstName');
        const lastName = readField('lastName');

        return `${firstName} ${lastName}`;
      }
    },
    createdTimestamp: dateTimeFieldPolicy()

  }

};
